import { useDispatch } from "react-redux";
import { uploadProductImage } from "../../../../../../../../../../../store/webdavSlice";

/**
 * @desc Product image handlers.
 */
export const useHandlers = ({ product }) => {
  const dispatch = useDispatch();

  // METHODS ------------------------------------------------------------------

  /**
   * @desc Handle product image change.
   */
  const handleChange = (e) => {
    const files = e.target.files;
    if (files.length) {
      const file = files[0];
      const fileType = file.name.split(".")[1];
      const form = new FormData();
      const filename = window.crypto.randomUUID() || product.sku;
      form.append("image", file);
      form.append("filename", `${filename}-${Date.now()}.${fileType}`);

      dispatch(uploadProductImage({ image: form, sku: product.sku }));
    }
  };

  // HOOK ---------------------------------------------------------------------

  return { handleChange };
};
